import styled from "@emotion/styled";

export const AggregationAndBreakoutDescription = styled.span`
  cursor: pointer;
`;
